const notifications = {
    title: "List notifications",
    markAsRead: "Mark as Read",
    seeAllNotifications: "See all notifications",
    seeMore: "See More",
    noNotifications: "There is no notifications to show",
  };
  
  export default notifications;